import { useState } from 'react'
import { supabase } from '../lib/supabaseClient'

const STRIPE_PRICE_ID = 'price_1T8tCxLAEdzAF7D7PdES1Pa3'

export default function SubscribeButton({ trustId, trustName }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubscribe = async () => {
    setError(null)
    setLoading(true)

    try {
      // Get fresh session
      const { data: refreshData } = await supabase.auth.refreshSession()
      const token = refreshData?.session?.access_token

      console.log('Token exists:', !!token)
      console.log('Token preview:', token?.substring(0, 30))
      console.log('Trust ID:', trustId)
      console.log('Supabase URL:', process.env.REACT_APP_SUPABASE_URL)

      if (!token) throw new Error('No auth token available')

      const response = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-checkout-session`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY
          },
          body: JSON.stringify({
            trust_id: trustId,
            trust_name: trustName,
            price_id: STRIPE_PRICE_ID,
            success_url: `${window.location.origin}/trusts/${trustId}?subscribed=true`,
            cancel_url: `${window.location.origin}/trusts/${trustId}`
          })
        }
      )

      const text = await response.text()
      console.log('Raw response:', text)

      const data = JSON.parse(text)

      if (data.error) throw new Error(data.error)
      if (!data.url) throw new Error('No checkout URL returned')

      window.location.href = data.url

    } catch (err) {
      console.error('Subscribe error:', err.message)
      setError(err.message)
      setLoading(false)
    }
  }

  return (
    <div>
      {error && (
        <p className="text-red-500 text-sm mb-2">{error}</p>
      )}
      <button
        onClick={handleSubscribe}
        disabled={loading}
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2.5 rounded-lg transition disabled:opacity-50 whitespace-nowrap"
      >
        {loading ? 'Redirecting to checkout...' : 'Subscribe — $99/year'}
      </button>
    </div>
  )
}